import * as actionTypes from "../actions/actionTypes";
import { toggleTournamentHistoryDetails } from "../actions/multipleReportCardsAction";

const initialState = {
  promotionalContent: {},
  multiGamePlayerReports: [],
  gameType: "cash",
  playerReports: {},
  tournamentHistoryFlag: false,
  tournamentHistoryFullScreenFlag: false,
  activeTournyFilter: {
    feedGameType:'MTT',
    buyIn: "All",
    gameSubType: "All",
    trnyType: "All",
    gameSpeed: "All",
    dateRange: "This Year"
  },
  reportCardSetting: [
    {
      hitType: "6-seater",
      hitRange: "Select",
      hitLevel: "All Level",
      gameType: "cash",
      accountName: "",
      shift: "Select",
      userRole: localStorage.getItem("userRole"),
      userType: localStorage.getItem("loggedInType")
    },
    {
      hitType: "6-seater",
      hitRange: "Select",
      hitLevel: "All Level",
      gameType: "plo",
      accountName: "",
      shift: "Select",
      userRole: localStorage.getItem("userRole"),
      userType: localStorage.getItem("loggedInType")
    },
    {
      hitRange: "Select",
      gameType: "tournament",
      hitLevel: "All Level",
      hitType: "Full Ring",
      accountName: "",
      shift: "Select",
      userRole: localStorage.getItem("userRole"),
      userType: localStorage.getItem("loggedInType")
    },
    {
      hitRange: "Select",
      gameType: "spin",
      hitLevel: "All Level",
      hitType: "3 max",
      accountName: "",
      shift: "Select",
      userRole: localStorage.getItem("userRole"),
      userType: localStorage.getItem("loggedInType")
    }
  ],
  rangeList: [
    { "0 day": "Today" },
    { "1 days": "Yesterday" },
    { "7 days": "Last 7 days" },
    { "0 month": "This Month" },
    { "0 month": "This Month" },
    { "1 month": "Last Month" },
    { "0 year": "This Year" },
    { "1 year": "Last Year" },
    { "1 week": "Last Week" },
    { "0 week": "This Week" }
  ],
  myStatisticData: [],
  myStatTopHands: {},
  currency:'',
  rake: undefined,
  profit: undefined,
  myStatHands: 0,
  mycashoutStatsHands:0,
  cashoutProfit:undefined,
  myStatPlayerLevels: [],
  myStatPlayerGameSubTypes: [],
  myStatPlayerHitTypes: [],
  myStatGameType: ["Cash", "Mtts", "spin", "SitnGo"],
  myStatHitRange: [
    "Today",
    "Yesterday",
    "Last 7 days",
    "This Week",
    "Last Week",
    "This Month",
    "Last Month",
    "This Year",
    "Last Year"
  ],
  myStatSettings: {
    selectedGameType: "cash",
    selectedGameSubType: "All",
    selectedHitType: "6-seater",
    selectedHitLevel: "All Level",
    selectedHitRange: "This Week",
    gameType: "cash",
    gameSubType: "All",
    hitType: "6-seater",
    hitLevel: "All Level",
    hitRange: "This Week",
    selectedShowHandsStat: true,
    selectedShowProfitStat: false,
    selectedShowRakeStat: false,
    showHandsStat: true,
    showProfitStat: false,
    showRakeStat: false
  },
  tournyDtls: {},
  tournytype: [],
  tournySpeed: []
};

const setMultiReportCardDeatils = (state, action) => {
  return {
    ...state,
    multiGamePlayerReports: action.data
  };
};
const setMyStatTopHands = (state, action) => {
  return {
    ...state,
    myStatTopHands: action.data
  };
};
const setTopHands = (state, action) => {
  return {
    ...state,
    playerReports: { ...state.playerReports, topHands: action.data }
  };
};
const setMyStatSettings = (state, action) => {
  return {
    ...state,
    myStatSettings: {
      ...state.myStatSettings,
      ...action.data
    }
  };
};
const setPlayerLevels = (state, action) => {
  let hitLevel = "All Level"
  if (state.myStatSettings.selectedHitLevel != "All Level") {
    hitLevel = action.data.playerLevels.filter(data => {
      return (data.SB.toString() === state.myStatSettings.selectedHitLevel.split("/")[0] &&
        data.BB.toString() === state.myStatSettings.selectedHitLevel.split("/")[1])
    }).length > 0 ? state.myStatSettings.selectedHitLevel : "All Level";
  }
  return {
    ...state,
    myStatPlayerLevels: action.data.playerLevels,
    myStatSettings: { ...state.myStatSettings, selectedHitLevel: hitLevel }
  };
};
const setPlayerGameSubTypes = (state, action) => {
  let gameSubType = action.data.includes(state.myStatSettings.selectedGameSubType) ? state.myStatSettings.selectedGameSubType : "All";
  return {
    ...state,
    myStatPlayerGameSubTypes: action.data,
    myStatSettings: { ...state.myStatSettings, selectedGameSubType: gameSubType }
  };
};
const setPlayerHitTypes = (state, action) => {
  // remove "HU and 3 handed" option for cash
  if (state.myStatSettings.selectedGameType === "cash") {
    action.data = action.data.filter(data => data != "HU and 3 Handed")
  }
  let hitType = "All";
  //set default value as 6-seater for gameType cash and "All" for remaining gameType
  hitType = action.data.includes(state.myStatSettings.selectedHitType)
    ? state.myStatSettings.selectedHitType
    : (state.myStatSettings.selectedGameType === "cash"
      ? "6-seater"
      : "All");
  // set hitType to Full Ring for Mtts
  if (state.myStatSettings.selectedGameType === "tournament") {
    hitType = "Full Ring"
  }
  return {
    ...state,
    myStatPlayerHitTypes: action.data,
    myStatSettings: { ...state.myStatSettings, selectedHitType: hitType }
  };
};

const setSingleReportCardDeatils = (state, action) => {
  if (state.multiGamePlayerReports.length === 0) {
    let data = initialState.reportCardSetting.filter(
      obj => obj.gameType != action.data.gameType
    );
    data[0].summaryInfo = [{ points: 0 }];
    state.multiGamePlayerReports = data;
  }
  // let updatedGameIndex = state.multiGamePlayerReports.findIndex(obj => obj.gameType === action.data.gameType)
  var updatedGameIndex = -1;
  for (var i = 0; i < state.multiGamePlayerReports.length; ++i) {
    if (state.multiGamePlayerReports[i].gameType === action.data.gameType) {
      updatedGameIndex = i;
      break;
    }
  }
  return {
    ...state,
    playerReports: action.data,
    multiGamePlayerReports: [
      ...state.multiGamePlayerReports.slice(0, updatedGameIndex),
      action.data,
      ...state.multiGamePlayerReports.slice(updatedGameIndex + 1)
    ]
  };
};
const setTournyFilter = (state, action) => {
  return {
    ...state,
    activeTournyFilter: action.data
  };
}
const setMyStatisticsDeatils = (state, action) => {
  let {
    myStatisticData,
    myStatTopHands,
    rake,
    profit,
    myStatHands,
    mycashoutStatsHands,
    cashoutProfit,
    myStatPlayerLevels,
    myStatPlayerGameSubTypes,
    myStatPlayerHitTypes,
    winRate,
    evAllinAdjusted,
    tournyDtls,
    tournytype,
    tournySpeed,
    currency
  } = initialState;
  if (action.data.myStatisticData) {
    myStatisticData = action.data.myStatisticData.sort((a, b) => {
      return a.order - b.order;
    });
  }
  if (action.data.topHands) {
    myStatTopHands = action.data.topHands;
  }
  if (action.data.currency) {
    currency = action.data.currency;
  }
  if (action.data.myStatistics && action.data.myStatistics.rake) {
    rake = action.data.myStatistics.rake;
  }
  if (action.data.myStatistics && action.data.myStatistics.profit) {
    profit = action.data.myStatistics.profit;
  }
  if (action.data.myStatistics && action.data.myStatistics.hands) {
    myStatHands = action.data.myStatistics.hands;
    evAllinAdjusted = action.data.myStatistics.EvAllinAdjusted;
    winRate = action.data.myStatistics.WinRate;
  }
  if (action.data.myStatistics && action.data.myStatistics.cashoutAmount) {
    cashoutProfit = action.data.myStatistics.cashoutAmount;
  }
  if (action.data.myStatistics && action.data.myStatistics.cashouthands) {
    mycashoutStatsHands = action.data.myStatistics.cashouthands;
  }
  if (action.data.playerLevels) {
    myStatPlayerLevels = action.data.playerLevels;
  }
  if (action.data.playerGameSubTypes) {
    myStatPlayerGameSubTypes = action.data.playerGameSubTypes;
  }
  if (action.data.playerHitTypes) {
    if (state.myStatSettings.selectedGameType === "cash") {
      action.data.playerHitTypes = action.data.playerHitTypes.filter(data => data != "HU and 3 Handed")
    }
    myStatPlayerHitTypes = action.data.playerHitTypes;
  }
  return {
    ...state,
    myStatisticData,
    myStatTopHands,
    rake,
    profit,
    winRate,
    myStatHands,
    mycashoutStatsHands,
    cashoutProfit,
    evAllinAdjusted,
    myStatPlayerLevels,
    myStatPlayerGameSubTypes,
    myStatPlayerHitTypes,
    currency,
    tournyDtls: action.data.tournyDtls ? action.data.tournyDtls : tournyDtls,
    tournytype: action.data.tournytype ? action.data.tournytype : tournytype,
    tournySpeed: action.data.tournySpeed ? action.data.tournySpeed : tournySpeed
  };
};

const setGameType = (state, action) => {
  return {
    ...state,
    gameType: action.data
  };
};

const setLevelInfo = (state, action) => {
  return {
    ...state,
    starsDetails: action.data.filter(
      key => Object.keys(key)[0] === "starDetails"
    )[0].starDetails,
    medalsDetails: action.data.filter(
      key => Object.keys(key)[0] === "medalDetails"
    )[0].medalDetails
  };
};

const setReportCardSetting = (state, action) => {
  return {
    ...state,
    reportCardSetting: action.data
  };
};
const setRange = (state, action) => {
  return {
    ...state,
    settingValues: { ...state.settingValues, ...action.data }
  };
};
const setType = (state, action) => {
  return {
    ...state,
    settingValues: { ...state.settingValues, ...action.data }
  };
};
export const setLevel = (state, action) => {
  return {
    ...state,
    settingValues: { ...state.settingValues, ...action.data }
  };
};
export const setMissions = (state, action) => {
  return {
    ...state,
    playerReports: { ...state.playerReports, mission: { ...action.data } }
  };
};

const setPromotionalContent = (state, action) => {
  return {
    ...state,
    promotionalContent: action.data[0]
  };
};

const multipleReportCardsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_REPORT_CARD_DETAILS:
      return setMultiReportCardDeatils(state, action);
    case actionTypes.SET_LEVEL_INFO:
      return setLevelInfo(state, action);
    case actionTypes.SET_REPORT_CARD_SETTING:
      return setReportCardSetting(state, action);
    case actionTypes.SET_MY_STAT_TOP_HANDS:
      return setMyStatTopHands(state, action);
    case actionTypes.SET_SINGLE_REPORT_CARD_DETAILS:
      return setSingleReportCardDeatils(state, action);
    case actionTypes.SET_TOP_HANDS:
      return setTopHands(state, action);
    case actionTypes.SET_MY_STATISTICS_DETAILS:
      return setMyStatisticsDeatils(state, action);
    case actionTypes.SET_GAME_TYPE:
      return setGameType(state, action);
    case actionTypes.SET_RANGE:
      return setRange(state, action);
    case actionTypes.SET_TYPE:
      return setType(state, action);
    case actionTypes.SET_LEVEL:
      return setLevel(state, action);
    case actionTypes.SET_MISSIONS:
      return setMissions(state, action);
    case actionTypes.SET_MY_STAT_SETTINGS:
      return setMyStatSettings(state, action);
    case actionTypes.SET_PLAYER_LEVELS:
      return setPlayerLevels(state, action);
    case actionTypes.SET_PLAYER_GAME_SUB_TYPES:
      return setPlayerGameSubTypes(state, action);
    case actionTypes.SET_PLAYER_HIT_TYPES:
      return setPlayerHitTypes(state, action);
    case actionTypes.SET_PROMOTIONAL_CONTENT:
      return setPromotionalContent(state, action);
    case actionTypes.SET_TOURNY_FILTER:
      return setTournyFilter(state, action);
    case actionTypes.TOGGLE_TOURNAMENT_HISTORY_DETAILS:
      return {
        ...state,
        tournamentHistoryFlag: action.data
      }
    case actionTypes.TOGGLE_TOURNAMENT_HISTORY_FULL_SCREEN:
      return {
        ...state,
        tournamentHistoryFullScreenFlag: action.data
      }
    default:
      return state;
  }
};

export default multipleReportCardsReducer;



/** WEBPACK FOOTER **
 ** ./src/store/reducer/multipleReportCardsReducer.js
 **/